import React, { useContext } from 'react';
import { Box, Stack, Typography, CircularProgress } from '@mui/material';
// components
import ListView from './ListView';
// contexts
import { CardsContext } from 'contexts/cardResult';
import PageBox from './PageBox';
import ExtendedSearchForm from './ExtendedSearchForm';

type Props = {
  loading: boolean,
};

const PageContent: React.FC<Props> = ({ loading }) => {
  const { cardResult } = useContext(CardsContext);
  return (
    loading
      ? (
        <Stack alignItems='center' sx={{ m: 3 }}>
          <CircularProgress />
        </Stack>
      )
      : (
        <Box>
          <Stack alignItems='center'>
            <ExtendedSearchForm />
            <Typography variant='subtitle2'>
              {`ヒット件数: ${cardResult.count}`}
            </Typography>
            <PageBox count={cardResult.count} />
          </Stack>
          <Stack>
            <ListView cardResult={cardResult} />
          </Stack>
          <Stack alignItems='center'>
            <PageBox count={cardResult.count} />
          </Stack>
        </Box>
      )
  );
};

export default PageContent;
